import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { MinusCircleIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default from 'react';
import Button from './Button.js';

var _excluded = ["as", "children", "className", "type", "size"],
  _excluded2 = ["as", "className", "clickable", "divider", "id", "selected", "onRemoveItem"];
var List = function List(props) {
  var _props$as = props.as,
    As = _props$as === void 0 ? "".concat(props.type === 'ordered' ? 'ol' : 'ul') : _props$as,
    children = props.children,
    className = props.className,
    _props$type = props.type,
    type = _props$type === void 0 ? null : _props$type,
    _props$size = props.size,
    size = _props$size === void 0 ? 'normal' : _props$size,
    otherProps = _objectWithoutProperties(props, _excluded);
  var finalClasses = classnames('C-List', _defineProperty(_defineProperty({}, "--type-".concat(type), type), "--size-".concat(size), size), className);
  return /*#__PURE__*/React__default.createElement(As, _extends({
    className: finalClasses
  }, otherProps), children);
};
List.displayName = 'List';
var ListItem = List.Item = function (props, context) {
  var _props$as2 = props.as,
    As = _props$as2 === void 0 ? "".concat(props.onClick || props.clickable ? 'button' : 'span') : _props$as2,
    className = props.className,
    clickable = props.clickable,
    divider = props.divider,
    id = props.id,
    selected = props.selected,
    onRemoveItem = props.onRemoveItem,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var finalClasses = classnames('C-ListItem__item', {
    '--clickable': clickable || otherProps.onClick,
    '--removable': onRemoveItem,
    isSelected: selected
  }, className);
  var finalParentClasses = classnames('C-ListItem', {
    '--divider': divider,
    isSelected: selected
  }, className);
  var button;
  if (onRemoveItem) {
    button = /*#__PURE__*/React__default.createElement(Button, {
      type: "destructive",
      onClick: onRemoveItem,
      className: "C-ListItem__item__button",
      "aria-label": "remove this",
      iconOnly: true,
      role: "button",
      "data-testid": otherProps['data-testid'] ? "".concat(otherProps['data-testid'], "_removeButton") : null
    }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
      icon: MinusCircleIcon
    }));
  }
  return /*#__PURE__*/React__default.createElement("li", {
    className: finalParentClasses,
    id: id
  }, /*#__PURE__*/React__default.createElement(As, _extends({
    className: finalClasses
  }, otherProps, As == 'button' ? {
    'aria-pressed': selected ? true : false
  } : {})), button);
};
ListItem.displayName = 'List.Item';

export { ListItem, List as default };
